export enum BALANCE_CHART_TYPE {
    TOTAL_SEQUESTRATION,
    NO_ACTION_SEQUESTRATION,
    TOTAL_EMISSIONS,
    NO_ACTION_EMISSION,
}
